<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="9" cy="7.5" r="2.75" stroke="currentColor" stroke-width="1.5" />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="1.5"
      d="M4.25 18.5v-.75A4.75 4.75 0 0 1 9 13h0a4.75 4.75 0 0 1 4.75 4.75v.75"
    />
    <circle cx="16.5" cy="9" r="2" stroke="currentColor" stroke-width="1.5" />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="1.5"
      d="M16.5 14.5a3.5 3.5 0 0 1 3.5 3.5v.5"
    />
  </svg>
</template>
